import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import SliderListItem from '../../../../../list-items/SliderListItem';

const TextDriftRotationListItem = (props) => {
    const { rotation, index, updateTextElement } = props;

    const onRotationChange = (value) => updateTextElement(index, { drift: { rotation: value } });

    return (
        <SliderListItem
            title='Rotation'
            displayMultiplier={2.5}
            value={rotation}
            min={0}
            max={25}
            step={1}
            onValueChange={onRotationChange}
            toolTip='Maximum rotation in degrees.'
        />
    );
};

const mapStateToProps = (state, ownProps) => {
    const { rotation } = state.createPreview.present.videoSettings.text.textElements[ownProps.index].drift;
    return { rotation };
};

const mapDispatchToProps = (dispatch) => {
    const updateTextElement = (index, properties) => dispatch(createActions.updateTextElement(index, properties));
    return { updateTextElement };
};

export default connect(mapStateToProps, mapDispatchToProps)(TextDriftRotationListItem);
